const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const updateLeadFileVerificationApi = async (leadId, payload) => {
  const token = localStorage.getItem('token');

  const response = await fetch(`${API_BASE_URL}/admin/lead/leads/${leadId}/files/verification`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let errorData = null;

    try {
      errorData = await response.json();
    } catch (parseError) {
      errorData = null;
    }

    throw {
      ...(errorData || {}),
      statusCode: response.status,
      status: response.status,
      message: errorData?.message || 'Failed to update verification status.',
    };
  }

  return response.json();
};

export default updateLeadFileVerificationApi;
